import React from 'react'
import Navbar from '../Components/NavBar'
import Footer from '../Components/Footer'
import ContactOne from '../Components/ContactOne'
import HomeTwo from "../Home/HomeTwo"
import ContactThree from '../Components/ContactThree'
const ContactMain = () => {
  return (
    <div>
      <Navbar />
      <ContactOne />
      <HomeTwo />
      <ContactThree />
      <Footer />
    </div>
  )
}

export default ContactMain